<template>
  <div class="apple-card">
    <div class="container_info">
      <div class="info1">{{ $t('menu.hanadaem') }}</div>
      <div class="info1">{{ $t('menu.accountHolder') }} : {{ $t('menu.hanadaem') }}</div> 
      <div class="info2">
        BLOG 
        <a href="https://contents.geek9.kr" target="_blank">#1</a> | 
        <a href="https://sosoceo.tistory.com/category/GEEK9" target="_blank">#2</a>
      </div> 
    </div>
    <div class="container_info">
      <div class="info1">{{ $t('menu.geek9Representive') }}({{ $t('menu.geek9Phone') }})</div>
      <div class="info1">{{ $t('menu.kakaoBank') }} 3333-24-9473287</div>
      <div class="info2"><a href="https://www.instagram.com/geek9geek9/" target="_blank">INSTAGRAM</a></div>
    </div>
    <div class="container_info">
      <div class="info1">{{ $t('menu.geek9BizNum') }}</div>
      <div class="info1">{{ $t('menu.kookminBank') }} 420401-04-221057</div>
      <div class="info2"><a href='https://www.youtube.com/@sosoceo' target="_blank">Youtube</a></div>
    </div>
    <div class="container_info">
      <div class="info1">2018-인천연수구-0625</div>
      <div class="info1"><a href="https://qr.kakaopay.com/Ej79lhQuc" target="_blank">{{ $t('menu.kakaoPay') }} (mobile)</a></div>
      <div class="info2">
        <a href='/notice'>{{ $t('menu.notify') }}</a>
      </div>
    </div>
    <div class="container_info">
      <div class="info1">{{ $t('menu.geek9Addr1') }}, {{ $t('menu.geek9Addr2') }}</div>
      <div class="info1">Copyright © <a href="http://geek9.kr" target="_blank"><strong>geek9.kr</strong></a></div>
      <div class="info2"><a href="https://geek9.kr/biz" target="_blank">B2B</a></div>
    </div> 
    <div class="container_policy"> 
      {{ $t('policy.g01') }}
      {{ $t('policy.g02') }}
      {{ $t('policy.g03') }}
    </div>                 
  </div> 
</template>

<script>
export default {
}
</script>

<style scoped>
.main {
  font-size: 10px;
}
.container_info {
  display: flex;
}
.info1 {
  width: 40%;
  padding-left: 10px;
  padding-bottom: 10px;
  border-right: 1px dotted gray;
}
.info2 {
  width: 20%;
  padding-left: 10px;
  padding-bottom: 10px;
  /* border-right: 1px dotted gray; */
}
.container_policy {
  padding: 10px;
  font-weight: bold;
}
</style>
